












































































import { Component, Vue, Prop } from "vue-property-decorator";
import SideTabRight from "@/components/SideTabRight.vue";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import * as util from "@/service/util";
import Number from "@/shared/filters/Number.ts";
import { kbnSkn } from "@/model/KbnSKn";
import requestService from "@/service/requestService";
import { CustomerSave } from "@/model/CustomerSave";
import { Getter, Action } from "vuex-class";
import { INSPECT_TYPE } from "@/model/InspectType";
import { ShakenShohiyou } from "@/model/ShakenShohiyou";
import { CouponData } from "@/model/Coupon";
import { UserService } from "@/service/UserService";
import { SocketControllers } from "@/service/SocketControllers";
import { SeibiItem } from "@/model/InspectionSeibi";
import { SeibiItemSave } from "@/model/CustomerSave";
import TopBarTitle from '@/components/common/TopBarTitle.vue';
import { MESSAGE } from "@/model/Message";

@Component({
  filters: {
    Number
  },
  components: {
    appSideTabRight: SideTabRight,
    ConfirmDialog,
    TopBarTitle
  }
})
export default class PaymentDetail extends Vue {
  showAside: boolean = true;
  $refs!: {
    confirmDialog: ConfirmDialog;
    sideTab: SideTabRight;
    cancelDialog: ConfirmDialog;
  };
  total: number = 0;

  listPaymentMethod: kbnSkn[] = [];
  listDeposit: kbnSkn[] = [];
  reqService: requestService;
  sktControll: SocketControllers;
  userService: UserService;
  dataForSave: CustomerSave;
  strNotice: string = "";
  isUserMode: boolean = false;

  updating: boolean = false;
  loadingText: string = MESSAGE.Loading;

  @Prop() onUserConfirmUpdating: boolean;

  @Getter("sumPriceByType", { namespace: "InspectSeibi" })
  sumPrice!: (inspectType: number) => any;
  @Getter("getSeibiData", { namespace: "InspectSeibi" })
  seibi: any;
  @Getter("getManualSeibiData", { namespace: "InspectSeibi" })
  seibiManual: any;

  @Getter("isConfirmLegal56", { namespace: "InspectSeibi" })
  isConfirmLegal56: number;
  @Getter("isConfirmRecommend", { namespace: "InspectSeibi" })
  isConfirmRecommend: number;

  @Getter("listInspectByType", { namespace: "InspectSeibi" })
  listInspect!: (inspectType: number) => SeibiItem[];

  @Getter("dataForSavePayment", { namespace: "Shohiyou" })
  shakenShohiyou: ShakenShohiyou;
  @Getter("isConfirm", { namespace: "Shohiyou" })
  isConfirmShohiyou: number;

  @Getter("total", { namespace: "Shohiyou" })
  totalShohiyou: any;

  @Getter("currentState", { namespace: "Coupon" })
  couponData: CouponData;
  @Getter("total", { namespace: "Coupon" })
  totalCoupon: any;

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  @Getter("loadData", { namespace: "Payment" })
  loadData: number;
  @Getter("sknPaymentMethod", { namespace: "Payment" })
  sknPaymentMethod: number;
  @Getter("sknPaymentDeposit", { namespace: "Payment" })
  sknPaymentDeposit: number;

  @Action("updatetPayment", { namespace: "Payment" })
  updatetPayment: any;

  @Getter("stateId", { namespace: "SubHeader" })
  stateId: number;

  @Getter("isConfirm", { namespace: "Option" })
  isConfirmOption: number;

  /** 2023-10-19 invoice [START] */
  @Getter("isExcludingTax", { namespace: "FunctionSetting" })
  isExcludingTax: any;

  @Getter("taxLabel", { namespace: "FunctionSetting" })
  taxLabel: string;
  /** 2023-10-19 invoice [END] */

  loading: boolean = false;
  /** 2022-11-17 sh #8121(BQR986) reload after change shaken-shurui. [END] */

  created() {
    this.reqService = new requestService();
    this.sktControll = new SocketControllers();
    this.userService = new UserService();
    this.reqService.getKbnSkns("skn_payment_method").then((res: any) => {
      this.listPaymentMethod = res;
    });
    this.reqService.getKbnSkns("skn_payment_deposit").then((res: any) => {
      this.listDeposit = res;
    });
    this.reqService.getPaymentNotice().then((res: any) => {
      if (res.topicsBody) {
        this.strNotice = res.topicsBody;
      }
    });

    if (!this.loadData) {
      this.userService.getAllData();
    }
    if (this.$route.meta == "user") this.isUserMode = true;

    /** 2022-11-17 sh #8121(BQR986) reload after change shaken-shurui. [START] */
    this.sktControll.connectSocket(this.onConnect);
    /** 2022-11-17 sh #8121(BQR986) reload after change shaken-shurui. [END] */
  }

  mounted() {
    this.$refs.sideTab.onActive(4);
    /** 2023-10-19 invoice [START] */
    if( this.isExcludingTax ){
      /** 2023-10-23 disp uchizei (invoice part 8) [START] */
      //this.total = this.$refs.sideTab.sumZnCalcZk;
      this.reqService.getZeikomi(
        this.$refs.sideTab.sumCalcKazeiZn
      ).then(
        (res: any) => {
          if (res) {
            //console.log("mama", res);
            this.total = res.priceZk + this.$refs.sideTab.sumCalcHikazeiZn;
          }
        },
        (err: any) => {}
      );
      /** 2023-10-23 disp uchizei (invoice part 8) [END] */
    }else{
      this.total = this.$refs.sideTab.sum;
    }
    /** 2023-10-19 invoice [END] */
  }

  onConfirm() {
    this.$refs.confirmDialog.onOpen();
    // let seibiList: any = {};
    // if (this.seibi.length > 0) {
    //   this.seibi.forEach((seibi: SeibiItem[], i: number) => {
    //     let mapSeibi: any = [];
    //     try {
    //       if (seibi && seibi.length > 0) {
    //       mapSeibi = seibi.map((item: SeibiItem) => {
    //         let seibiSave: SeibiItemSave = {
    //           sknUketsukeExtendsId: item.sknUketsukeExtendsId,
    //           sknUketsukeInspectSeibiId: item.sknInspectSeibiId,
    //           doTenken: item.doTenken,
    //           koukanMeyasuTime: item.koukanMeyasuTime,
    //           buhinZk: item.buhinZk ? +item.buhinZk : 0,
    //           kouchinZk: item.kouchinZk ? +item.kouchinZk : 0,
    //         };
    //         return { ...seibiSave };
    //       });
    //     }
    //     } catch(ex) {
    //       console.log(ex);
    //       console.log(seibi, this.seibi);
    //     }

    //     seibiList[i.toString()] = mapSeibi;
    //   });
    // }
    // let seibiManualList: any = {};
    // if (this.seibiManual && this.seibiManual.length > 0) {
    //   let listManual = this.seibiManual.map((item: any) => {
    //     return {
    //       sknUketsukeExtendsId: item.sknUketsukeExtendsId,
    //       sknUketsukeManualSeibiId: item.sknUketsukeManualSeibiId,
    //       doTenken: item.doTenken,
    //       buhinZk: item.buhinZk ? +item.buhinZk : 0,
    //       kouchinZk: item.kouchinZk ? +item.kouchinZk : 0,
    //     };
    //   });
    //   seibiManualList = { "2": listManual };
    // }

    // this.dataForSave = {
    //   sknUketsukeExtendsId: this.uketsukeExtendsId,
    //   sknUketsukeExtends: {
    //     isHikazei: 0,
    //     sknPaymentMethod: this.sknPaymentMethod,
    //     sknPaymentDeposit: this.sknPaymentDeposit,
    //     sknPaymentZn: null,
    //     sknPaymentZk: this.sumZk
    //   },
    //   inspectSeibi: {
    //     subTotalLegalZn: null,
    //     subTotalLegalZk: this.sumPriceLegal56.totalZk,
    //     subTotalRecommendZn: this.sumPriceRecommend.totalZn,
    //     subTotalRecommendZk: this.sumPriceRecommend.totalZk,
    //     isHikazei: 0,
    //     items: seibiList,
    //     manualItems: seibiManualList
    //   },
    //   shakenShohiyou: this.shakenShohiyou,
    //   coupon: { ...this.couponData.coupon, isHikazei: 0 },
    //   proposal: this.couponData.proposal,
    //   sknUketsukeUserJouhou: {
    //     isConfirmHiyou: this.shakenShohiyou.isConfirm
    //       ? this.shakenShohiyou.isConfirm
    //       : 0,
    //     isConfirmCoupon: this.couponData.isConfirm
    //     ? this.couponData.isConfirm
    //     : 0,
    //     isConfirmInspect: this.isConfirmLegal56,
    //     isConfirmRecommend: this.isConfirmRecommend,
    //     isConfirmPayment: 1
    //   }
    // };
    this.dataForSave = this.userService.getDataForSaveAk7(
      this.seibi,
      this.seibiManual,
      this.sumPriceRecommend,
      this.sknPaymentMethod,
      this.sknPaymentDeposit
    );
    console.log(this.dataForSave);
  }

  onSubmitConfirm() {
    this.$set(this, "updating", true);
    this.reqService.savePayment(this.dataForSave).then((res: any) => {
      this.$set(this, "updating", false);
    });
    this.$emit("onConfirmPayment");
  }

  changePayment(payment: number) {
    let _payment = payment;
    if (this.sknPaymentMethod === payment) {
      _payment = 0;
    }
    this.updatetPayment({ sknPaymentMethod: _payment });
  }

  changeHasDeposit(deposit: number) {
    let _deposit = deposit;
    if (this.sknPaymentDeposit === deposit) {
      _deposit = 0;
    }
    this.updatetPayment({ sknPaymentDeposit: _deposit });
  }

  get sumZk() {
    return (
      +this.totalShohiyou.totalZk +
      +this.totalCoupon.subTotalZk +
      +this.sumPriceRecommend.totalZk +
      +this.sumPriceLegal56.totalZk
    );
  }

  // get sumZn() {
  //   return (
  //     +this.totalShohiyou.totalZn +
  //     +this.totalCoupon.subTotalZn +
  //     +this.sumPriceRecommend.totalZn +
  //     +this.sumPriceLegal56.totalZn
  //   );
  // }

  get sumPriceLegal56() {
    return this.sumPrice(INSPECT_TYPE.LEGAL56);
  }
  get sumPriceRecommend() {
    return this.sumPrice(INSPECT_TYPE.RECOMMEND);
  }

  get disableConfirm() {
    let listRecommend = this.listInspect(INSPECT_TYPE.RECOMMEND);
    return (
      this.isConfirmShohiyou == 0 ||
      this.isConfirmOption == 0 ||
      this.couponData.isConfirm == 0 ||
      this.isConfirmLegal56 == 0 ||
      (this.isConfirmRecommend == 0 && listRecommend.length > 0)
    );
  }

  gotoWorkOrder() {
    this.$router.push({ name: "userworkorder" });
  }

  onCancel() {
    if (this.$refs.cancelDialog) {
      this.$refs.cancelDialog.onOpen();
    }
  }

  cancel() {
    const data = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      uketsukeCd: this.uketsukeCd,
      yoyakuNo: this.yoyakuNo
    };
    this.reqService.saveCancel(data).then((res: any) => {
      if (this.isUserMode) {
        this.$router.push({ name: "reservationNumber" });
      } else {
        this.$router.push({ name: "reservation" });
      }
    });
  }

  /** 2022-11-17 sh #8121(BQR986) reload after change shaken-shurui. [START] */
  onConnect() {
    if (this.uketsukeCd && this.uketsukeExtendsId) {
      if (this.sktControll.checkSocket()) {
        if (this.isUserMode) {
          this.sktControll.socketShohiyouReload(this.onUpdateTotal);
        }
      }
    }
  }

  onUpdateTotal() {
    this.$set(this, "updating", true);
    setTimeout(() => {
      this.$set(this, "updating", false);
      /** 2023-10-23 disp uchizei (invoice part 8) [START] */
      if( this.isExcludingTax ){
        //this.total = this.$refs.sideTab.sumZnCalcZk;
        this.reqService.getZeikomi(
          this.$refs.sideTab.sumCalcKazeiZn
        ).then(
          (res: any) => {
            if (res) {
              this.total = res.priceZk + this.$refs.sideTab.sumCalcHikazeiZn;
            }
          },
          (err: any) => {}
        );
      }else{
        this.total = this.$refs.sideTab.sum;
      }
      /** 2023-10-23 disp uchizei (invoice part 8) [END] */
    }, 2000);
  }

  destroyed() {
    this.sktControll.freeSocketResources();
  }
  /** 2022-11-17 sh #8121(BQR986) reload after change shaken-shurui. [END] */
}
